import { clearWebStorage } from './webStorage.ts';
import { clearInMemoryData } from '../services/dataProvider.ts';

function clearSupportChatData(): void {
    clearWebStorage();
    clearInMemoryData();
}

export { clearSupportChatData };
